export default function(someVar) {
  const constructor = someVar.constructor;

  let type;

  switch (constructor) {
    case String:
      type = 'string';
      break;
    case Boolean:
      type = 'boolean';
      break;
    case Number:
      type = 'number';
      break;
    case Array:
      type = 'array';
      break;
    case Object:
      type = 'object';
      break;
    case Function:
      type = 'function';
      break;
    default:
      type = 'unknown'
  }

  return type;
};


// WEBPACK FOOTER //
// ./src/commonJS/getConstructorType.js